import sum from "lodash/sum";
import random from "lodash/random";

export const getHolos = () =>
  sum([random(1, 10), random(1, 10), random(1, 10)]);
